import { GeoJsonLayer, IconLayer } from '@deck.gl/layers'
import MapPin from 'src/assets/images/ic_map_pin.svg'
import { type Area, type AreaType } from 'src/api/fm/zones/zones.model'
import { getLayerStyleByAreaType } from 'src/utils/map/mapUtils'
import { MAP_AREA_TYPES } from 'src/redux/mapSettings/mapSettings.types'

export const createAreasLayers = (data: Record<AreaType, Area[]>, visibleAreas: AreaType[], onHover: any) =>
    (Object.entries(data) as [AreaType, Area[]][])
        .sort(([areaTypeA], [areaTypeB]) => MAP_AREA_TYPES.indexOf(areaTypeA) - MAP_AREA_TYPES.indexOf(areaTypeB))
        .filter(([areaType]) => visibleAreas.includes(areaType))
        .map(([areaType, features]) => {
            const style = getLayerStyleByAreaType(areaType)
            return new GeoJsonLayer<Area>({
                id: `${areaType}-layer`,
                data: features,
                pickable: true,
                extruded: false,
                wireframe: true,
                onHover,
                opacity: style.opacity,
                stroked: style.stroked,
                filled: style.filled,
                getFillColor: style.fill,
                getLineColor: style.line,
                lineWidthMinPixels: style.lineWidthMinPixels,
            })
        })

export const createAddressSearchPinLayer = (position: [number, number]) =>
    new IconLayer<[number, number]>({
        id: 'address-search-pin',
        data: [position],
        getPosition: d => d,
        // width and height must match the dimensions of ic_map_pin.svg. deck.gl needs them to size and anchor the icon.
        getIcon: () => ({ url: MapPin, width: 32, height: 44, anchorY: 44 }),
        getSize: 44,
        sizeUnits: 'pixels',
    })
